import _ from 'lodash';

export const mergeColumnsDataLites = (
    existingColumnDataLite: any[],
    inComingColumnDataLite: any[],
    offset = 0,
    size?: number,
) => {
    const existingDataBycolId = _.mapKeys(existingColumnDataLite, 'columnId');

    const incomingDataBycolId = _.mapKeys(inComingColumnDataLite, 'columnId');

    const mergedColumnDataLite = _.map(
        incomingDataBycolId,
        (columnData, columnId) => {
            const mergedDataValue = [
                ..._.get(existingDataBycolId, `${columnId}.dataValue`),
            ];
            mergedDataValue.splice(offset, size, ...columnData.dataValue);
            const mergedColumnData = {
                ...columnData,
                dataValue: mergedDataValue,
            };
            return mergedColumnData;
        },
    );

    return mergedColumnDataLite;
};
